var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBogicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 146.798,
    height: 25.648,
    viewBox: "0 0 146.798 25.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_731",
    "data-name": "Rectangle 731",
    width: 146.798,
    height: 25.648,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_48_4",
    "data-name": "Component 48 \\u2013 4",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M29.9,5.05C29.682,4.714,26.5,0,20.977,0H9.172A6.922,6.922,0,0,0,2.251,6.921V19.873c0,.382-.595.17-.595.17a1.825,1.825,0,0,0-.51-.086A1.142,1.142,0,0,0,0,21.1c0,1.363,2.123,1.911,2.973,1.911a3.886,3.886,0,0,0,.721-.042,7.008,7.008,0,0,0,5.478,2.675H20.935a6.922,6.922,0,0,0,6.922-6.921V11.636s1.443-1.826,1.613-2h0s1.146-1.571,1.443-2.164.042-.85-1.02-2.421",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M24.122,22a2.554,2.554,0,0,0,.85.127c1.274,0,1.826-.51,1.826-1.1,0-.68-.935-.68-1.02-1.316-.127-.765-.042-4.161,1.274-6.03l.892.382a1.383,1.383,0,0,0,.552.127.8.8,0,0,0,.595-.3,17.177,17.177,0,0,0,2.295-3.142c.127-.212-1.741-2.548-2.76-3.354a4.248,4.248,0,0,0-2.59-.894,4.1,4.1,0,0,0-3.907,2.76,19.837,19.837,0,0,1-5.86,2.805c-2.845.765-5.775.042-7.728.17A4.025,4.025,0,0,0,4.506,16.4c.042,2.208,1.571,4.2,1.571,6.285a2.273,2.273,0,0,1-2.251,2.333c-1.1,0-1.146-.425-1.486-.425a.272.272,0,0,0-.34.254c0,.552,1.363,1.062,2.123,1.062a3.366,3.366,0,0,0,2.885-1.443,2.538,2.538,0,0,0,2.548,1.486c1.613,0,2.293-.765,2.293-1.4,0-.51-.3-.721-.552-1.062a1.537,1.537,0,0,1-.3-.977,7.571,7.571,0,0,0,.85.042c1.146,0,1.528-.467,1.528-.935,0-.595-.68-.552-.68-1.528,0-.765.425-.977.765-.977.382,0,1.868.127,3.694.34.595.042,2.084.637,2.084,2.973v.85c0,1.4.552,3.185,3.1,3.185,1.7,0,2.675-.935,2.675-1.656,0-.467-.382-.637-.595-.935a2.194,2.194,0,0,1-.3-1.868",
    transform: "translate(-1.15 -3.74)",
    fill: "#f26724"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M63.4,19.1a.3.3,0,1,0,.3.3.29.29,0,0,0-.3-.3",
    transform: "translate(-36.306 -10.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M65.855,17a.255.255,0,1,0,.255.255A.244.244,0,0,0,65.855,17",
    transform: "translate(-37.744 -9.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M67.112,14.7a.212.212,0,1,0,.212.212.228.228,0,0,0-.212-.212",
    transform: "translate(-38.491 -8.458)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M46.94,17.08a.34.34,0,1,0-.34-.34c.042.212.17.34.34.34",
    transform: "translate(-26.812 -9.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M49.9,36.2a.3.3,0,0,0-.3.34.328.328,0,0,0,.3.34.335.335,0,0,0,.34-.34c-.042-.17-.17-.34-.34-.34",
    transform: "translate(-28.537 -20.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M54.34,37a.34.34,0,1,0,.34.34c-.042-.212-.17-.34-.34-.34",
    transform: "translate(-31.07 -21.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M50.44,29.4a.34.34,0,1,0,0,.68.313.313,0,0,0,.34-.34.335.335,0,0,0-.34-.34",
    transform: "translate(-28.826 -16.916)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M53.091,23.38a.343.343,0,1,0-.3-.34.34.34,0,0,0,.3.34",
    transform: "translate(-30.372 -13.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M41.24,20.28a.34.34,0,1,0-.34-.34c.042.212.17.34.34.34",
    transform: "translate(-23.532 -11.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M45.54,34.7a.34.34,0,1,0,.34.34c-.042-.212-.17-.34-.34-.34",
    transform: "translate(-26.006 -19.965)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M43.44,23.98a.3.3,0,0,0,.3-.34.328.328,0,0,0-.3-.34.34.34,0,1,0,0,.68",
    transform: "translate(-24.798 -13.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M38.64,29.2a.34.34,0,1,0,.34.34.365.365,0,0,0-.34-.34",
    transform: "translate(-22.037 -16.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M46.44,27.48a.34.34,0,1,0-.34-.34c.042.212.17.34.34.34",
    transform: "translate(-26.524 -15.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M34.54,21.7a.34.34,0,1,0,.34.34.335.335,0,0,0-.34-.34",
    transform: "translate(-19.677 -12.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M36.24,25.6a.34.34,0,1,0,.34.34c-.042-.212-.17-.34-.34-.34",
    transform: "translate(-20.655 -14.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M41.74,32.1a.34.34,0,1,0,.34.34c-.042-.17-.17-.34-.34-.34",
    transform: "translate(-23.82 -18.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M49.44,20.58a.34.34,0,1,0-.34-.34c.042.212.17.34.34.34",
    transform: "translate(-28.25 -11.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M54.94,30.8a.34.34,0,1,0,.34.34.335.335,0,0,0-.34-.34",
    transform: "translate(-31.415 -17.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M56.84,24.7a.34.34,0,1,0,0,.68.313.313,0,0,0,.34-.34.335.335,0,0,0-.34-.34",
    transform: "translate(-32.508 -14.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M56.34,18.5a.34.34,0,1,0,.34.34.313.313,0,0,0-.34-.34",
    transform: "translate(-32.22 -10.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M59.94,19.6a.34.34,0,1,0,.34.34.365.365,0,0,0-.34-.34",
    transform: "translate(-34.292 -11.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M53.74,16.2a.34.34,0,1,0,.34.34c-.042-.212-.17-.34-.34-.34",
    transform: "translate(-30.724 -9.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M52.24,13.3a.34.34,0,1,0,.34.34c-.042-.17-.17-.34-.34-.34",
    transform: "translate(-29.861 -7.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M55.34,13.3a.34.34,0,1,0,.34.34.365.365,0,0,0-.34-.34",
    transform: "translate(-31.645 -7.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M52.2,10.955a.274.274,0,0,1,.255-.255.244.244,0,0,1,.255.255.255.255,0,1,1-.51,0",
    transform: "translate(-30.033 -6.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M54.1,8.712a.212.212,0,1,1,.212.212.228.228,0,0,1-.212-.212",
    transform: "translate(-31.127 -4.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M56.5,7.67a.17.17,0,1,1,.17.17.183.183,0,0,1-.17-.17",
    transform: "translate(-32.508 -4.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M66.9,12.87a.17.17,0,1,1,.17.17.183.183,0,0,1-.17-.17",
    transform: "translate(-38.491 -7.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M66.3,20.37a.17.17,0,1,1,.17.17c-.042,0-.127-.085-.17-.17",
    transform: "translate(-38.146 -11.622)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M67.4,18.97a.17.17,0,1,1,.17.17.183.183,0,0,1-.17-.17",
    transform: "translate(-38.779 -10.817)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M65.2,21.87a.17.17,0,1,1,.17.17.183.183,0,0,1-.17-.17",
    transform: "translate(-37.513 -12.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M63.9,23.17a.17.17,0,1,1,.17.17c-.085,0-.127-.085-.17-.17",
    transform: "translate(-36.766 -13.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M68.4,17.47a.17.17,0,1,1,.17.17.183.183,0,0,1-.17-.17",
    transform: "translate(-39.355 -9.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M69.1,16.17a.17.17,0,1,1,.17.17c-.085,0-.127-.042-.17-.17",
    transform: "translate(-39.758 -9.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M20.253,39.717a5.143,5.143,0,0,1-.382-4.076,3.4,3.4,0,0,1,3.482-2,2.983,2.983,0,0,0-1.363-.255A3.4,3.4,0,0,0,18.9,37.042a3.909,3.909,0,0,0,1.363,2.675",
    transform: "translate(-10.869 -19.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M10.907,26.7a2.725,2.725,0,0,1-.807-1.953,2.81,2.81,0,0,1,2.76-2.76c1.571-.085,4.459.382,6.327.127.637,2.845,2.76,4.841,4.328,6.115-1.911-.85-3.822-3.1-6.03-4.328-2.293-1.274-4.629-1.486-5.86-.34A3.172,3.172,0,0,0,10.9,26.7",
    transform: "translate(-5.811 -12.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M25.563,39.9C25.69,40.707,24.2,41,24.2,41c1.363.255,1.783-.467,1.783-.467a3.241,3.241,0,0,0-.425-.637",
    transform: "translate(-13.924 -22.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M50.226,40.9h0a4.258,4.258,0,0,0-.255,3.527,4.585,4.585,0,0,1-1.571.8s2.038.255,2.675-.807c-1.274-.977-.892-3.354-.85-3.527",
    transform: "translate(-27.848 -23.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M59.934,10.261a1.352,1.352,0,0,0-1.656.935,1.319,1.319,0,0,0,1.231,1.443,1.352,1.352,0,0,0,1.656-.935,1.319,1.319,0,0,0-1.231-1.443m1.02,1.4a.986.986,0,0,1-1.189.68.935.935,0,0,1-.85-1.02.986.986,0,0,1,1.189-.68.935.935,0,0,1,.85,1.02",
    transform: "translate(-33.521 -5.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M62.094,12.572a.547.547,0,0,1,.637-.382.513.513,0,0,1,.467.552.547.547,0,0,1-.637.382.513.513,0,0,1-.467-.552",
    transform: "translate(-35.723 -7.009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M56.761,38.3h0c.467.892-1.062,1.231-1.062,1.231,1.1.17,1.7-.467,1.7-.765a2.749,2.749,0,0,1-.637-.467",
    transform: "translate(-32.047 -22.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M35.37,31.285s.212.255.552.595a13.626,13.626,0,0,0,1.363,1.146,10.386,10.386,0,0,0,1.486.935,2.793,2.793,0,0,0,.51.255,1.784,1.784,0,0,1,.212.085,1.782,1.782,0,0,0-.212-.085,2.918,2.918,0,0,1-.552-.255,12.756,12.756,0,0,1-1.571-.892,10.769,10.769,0,0,1-1.4-1.1,6.228,6.228,0,0,1-.595-.595.129.129,0,0,1,0-.17.321.321,0,0,1,.212.085h0",
    transform: "translate(-20.211 -17.951)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M59.794,9.927a2.294,2.294,0,0,0-3.864-.17.361.361,0,1,1-.551-.467,2.6,2.6,0,0,1,2-.89A2.565,2.565,0,0,1,59.8,9.928",
    transform: "translate(-31.81 -4.831)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M53.694,18.327a5.587,5.587,0,0,1-2.845-1.146,5.946,5.946,0,0,1-1.783-2c-.042-.127-.042-.3.085-.34a.229.229,0,0,1,.34.085,6.456,6.456,0,0,0,1.7,2.164,6.257,6.257,0,0,0,2.506,1.233",
    transform: "translate(-28.216 -8.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M49.4,22.144a6.893,6.893,0,0,1-4.458-2.208,9.324,9.324,0,0,1-1.4-1.953.248.248,0,0,1,.425-.255,8.369,8.369,0,0,0,1.656,2.463A6.417,6.417,0,0,0,49.4,22.144",
    transform: "translate(-25.028 -10.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M37.681,20.486a.24.24,0,0,1,.3.17,9.074,9.074,0,0,0,2.164,3.482,8.047,8.047,0,0,0,5.308,2.378,8.132,8.132,0,0,1-5.732-2.378,9.393,9.393,0,0,1-2.164-3.312.225.225,0,0,1,.127-.34",
    transform: "translate(-21.587 -11.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M57.76,14.677a2.493,2.493,0,0,0,1.4.425,1.724,1.724,0,0,0,1.827-1.4,2,2,0,0,1-2,1.783,2.959,2.959,0,0,1-1.486-.34.268.268,0,0,1-.127-.34c.127-.127.3-.212.382-.127",
    transform: "translate(-33.003 -7.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M84.637,41.016a1.081,1.081,0,0,1-.68,1.02,1.192,1.192,0,0,1,.807,1.062c0,.935-.637,1.363-1.783,1.363H80.9V39.7h1.953c1.061,0,1.783.382,1.783,1.316m-2.845.637h.977c.467,0,.85-.085.85-.552s-.382-.552-.85-.552h-.976Zm0,2h1.062c.51,0,.85-.127.85-.595,0-.425-.34-.552-.85-.552H81.792Z",
    transform: "translate(-46.546 -22.842)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M94.564,44.5l-.425-1.1H92.1l-.425,1.1H90.7l1.868-4.8h1.146l1.868,4.8Zm-.765-2-.68-1.868-.679,1.871Z",
    transform: "translate(-52.185 -22.842)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M107.1,44.5l-2.463-3.227V44.5H103.7V39.7h.892l2.421,3.185V39.7h.977v4.8Z",
    transform: "translate(-59.665 -22.842)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M117.277,42.505v2H116.3V39.7h.977v1.911h.425l1.613-1.911H120.5l-2,2.336,2.164,2.463h-1.231l-1.741-2Z",
    transform: "translate(-66.914 -22.842)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M136.211,41.905a2.485,2.485,0,1,1-.728-1.778,2.505,2.505,0,0,1,.728,1.778m-4.076,0a1.529,1.529,0,1,0,1.528-1.571,1.483,1.483,0,0,0-1.528,1.571",
    transform: "translate(-75.487 -22.669)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M145.935,42.545V44.5H145V39.7h3.527v.85h-2.59v1.1h2.421v.892Z",
    transform: "translate(-83.427 -22.842)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M163.134,40.05l-.68.68a1.531,1.531,0,0,0-1.146-.51,1.573,1.573,0,0,0-.042,3.143,1.241,1.241,0,0,0,1.363-1.062h-1.189v-.807h2.208v.255a2.31,2.31,0,0,1-2.336,2.463,2.506,2.506,0,1,1,.042-5.011,2.948,2.948,0,0,1,1.783.85",
    transform: "translate(-91.373 -22.554)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M172.3,44.5V39.7h3.527v.85h-2.59v1.062h2.506v.894h-2.506v1.1h2.633V44.5Z",
    transform: "translate(-99.134 -22.842)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M187.511,41.905a2.485,2.485,0,1,1-.728-1.778,2.506,2.506,0,0,1,.728,1.778m-4.076,0a1.529,1.529,0,1,0,1.528-1.571,1.483,1.483,0,0,0-1.528,1.571",
    transform: "translate(-105.003 -22.669)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M200.137,41.143a1.384,1.384,0,0,1-1.4,1.4h-.042l1.486,1.911h-1.146l-1.4-1.911h-.3V44.5H196.4V39.7h2.038c1.1,0,1.7.51,1.7,1.443m-2.845.595h1.062c.51,0,.807-.212.807-.595s-.3-.595-.807-.595h-1.062Z",
    transform: "translate(-113.001 -22.842)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M211.08,40.05l-.68.68a1.531,1.531,0,0,0-1.146-.51,1.573,1.573,0,0,0-.042,3.143,1.242,1.242,0,0,0,1.363-1.062h-1.231v-.807h2.208v.255a2.311,2.311,0,0,1-2.336,2.463,2.506,2.506,0,0,1,.042-5.011,3.07,3.07,0,0,1,1.826.85",
    transform: "translate(-118.933 -22.554)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_493",
    "data-name": "Rectangle 493",
    width: 0.935,
    height: 4.799,
    transform: "translate(93.506 16.858)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M227.764,44.5l-.425-1.1H225.3l-.425,1.1H223.9l1.868-4.8h1.146l1.868,4.8Zm-.721-2-.68-1.868-.68,1.868Z",
    transform: "translate(-128.823 -22.842)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M80.8,18.964V15.1h1.274v3.779c0,1.1.51,1.571,1.274,1.571.807,0,1.316-.425,1.316-1.146,0-.85-.935-1.02-.935-2.038H85c.042.552.977.807.977,2.164a2.605,2.605,0,0,1-5.179-.466",
    transform: "translate(-46.489 -8.688)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M94.9,18.964v-.425H96.17v.34c0,1.1.51,1.571,1.316,1.571a1.162,1.162,0,0,0,1.274-1.274c0-1.486-2.038-1.911-2.038-3.694V15.1h1.274v.3c0,1.4,2.084,1.528,2.084,3.779a2.367,2.367,0,0,1-2.633,2.463,2.4,2.4,0,0,1-2.55-2.675",
    transform: "translate(-54.598 -8.688)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M109.2,19.1v-.425h1.274v.34a1.171,1.171,0,0,0,1.231,1.274c.765,0,1.274-.467,1.274-1.571v-.976a1.048,1.048,0,0,0-1.1-1.189.93.93,0,0,0-1.062.935v.127h-1.274v-.127a2.032,2.032,0,0,1,2.084-2.084,1.538,1.538,0,0,1,1.363.721V14.9h1.264v3.864A2.382,2.382,0,0,1,111.7,21.44a2.194,2.194,0,0,1-2.506-2.336",
    transform: "translate(-62.827 -8.573)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M123.2,18.964v-.425h1.274v.34c0,1.1.51,1.571,1.316,1.571a1.162,1.162,0,0,0,1.274-1.274c0-1.486-2.038-1.911-2.038-3.694V15.1H126.3v.3c0,1.4,2.084,1.528,2.084,3.779a2.367,2.367,0,0,1-2.633,2.463,2.4,2.4,0,0,1-2.548-2.675",
    transform: "translate(-70.88 -8.688)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M145.358,19.374v2.084h-1.316v-2c0-.721-.34-1.1-.85-1.1a.939.939,0,0,0-.935,1.02v1.313h-1.316V19.328c0-.637-.34-1.02-.892-1.02-.51,0-.935.382-.935,1.146v1.957H137.8V18.527c0-2.885,2.084-3.527,3.779-3.527h1.912v1.189h-1.783c-1.4,0-2.506.425-2.675,1.486a1.429,1.429,0,0,1,1.146-.552,1.531,1.531,0,0,1,1.4,1.02,1.9,1.9,0,0,1,1.741-1.02,2.118,2.118,0,0,1,2.038,2.251",
    transform: "translate(-79.284 -8.63)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M157.8,18.847V17.574a2.373,2.373,0,0,1,2.421-2.675,1.859,1.859,0,0,1,1.868,1.1,1.874,1.874,0,0,1,1.826-1.1,2.219,2.219,0,0,1,2.164,2.421v4.119h-1.274V17.319c0-.765-.425-1.231-1.02-1.231s-1.016.466-1.016,1.231v1.528a2.391,2.391,0,0,1-2.506,2.675,2.362,2.362,0,0,1-2.463-2.675m3.694-.085V17.574c0-1.062-.51-1.528-1.189-1.528s-1.189.467-1.189,1.528v1.189c0,1.1.51,1.571,1.189,1.571.637,0,1.189-.467,1.189-1.571",
    transform: "translate(-90.791 -8.571)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M180.1,19.128v-.337h1.274v.256a1.212,1.212,0,0,0,1.363,1.189c.85,0,1.363-.34,1.363-.85,0-.552-.51-.765-1.061-.765h-.68V17.476h.68c.552,0,.935-.17.935-.68,0-.467-.467-.85-1.231-.85-.85,0-1.363.51-1.363,1.1v.17H180.1v-.212c0-1.231,1.062-2.208,2.675-2.208,1.486,0,2.548.892,2.548,2a1.272,1.272,0,0,1-1.02,1.274,1.282,1.282,0,0,1,1.1,1.4c0,1.146-1.062,1.953-2.675,1.953a2.269,2.269,0,0,1-2.633-2.293",
    transform: "translate(-103.622 -8.515)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M194.7,18.987v-.425h1.274v.384a1.171,1.171,0,0,0,1.274,1.231c.765,0,1.231-.467,1.231-1.528V17.416c0-1.062-.51-1.528-1.231-1.528a1.193,1.193,0,0,0-1.274,1.231v.127H194.7v-.127a2.353,2.353,0,0,1,2.548-2.421,2.4,2.4,0,0,1,2.548,2.675v1.274a2.382,2.382,0,0,1-2.548,2.675,2.227,2.227,0,0,1-2.548-2.336",
    transform: "translate(-112.022 -8.456)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M208.9,17.815v-.807a2.084,2.084,0,0,1,2.038-2.208,1.763,1.763,0,0,1,1.613,1.02,1.747,1.747,0,0,1,1.571-1.02,1.683,1.683,0,0,1,1.486,1.02,1.8,1.8,0,0,1,1.7-1.02,2.025,2.025,0,0,1,2,2.208v1.7h-1.274V17.05c0-.721-.34-1.1-.85-1.1a.962.962,0,0,0-.935,1.02v1.528h-1.274V16.964a.909.909,0,0,0-.892-1.02.932.932,0,0,0-.892,1.02v1.528h-1.274V16.964c0-.637-.34-1.02-.85-1.02-.467,0-.892.382-.892,1.146v.637c0,1.656.721,2.463,3.015,2.463H217.4v1.189h-4.374c-1.868-.042-4.119-.68-4.119-3.567",
    transform: "translate(-120.191 -8.515)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M243.558,17.008v4.328h-1.316V17.088c0-.721-.34-1.1-.85-1.1a.939.939,0,0,0-.935,1.02v2.675h-1.316V17.008c0-.637-.34-1.02-.892-1.02-.51,0-.935.382-.935,1.146v4.2H236V17.01a2.123,2.123,0,0,1,2.123-2.208,1.777,1.777,0,0,1,1.656,1.02,1.815,1.815,0,0,1,1.741-1.02,2.057,2.057,0,0,1,2.038,2.208",
    transform: "translate(-135.784 -8.515)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M256.9,18.964V15.1h1.274v3.779c0,1.1.51,1.571,1.274,1.571.807,0,1.316-.425,1.316-1.146,0-.85-.935-1.02-.935-2.038H261.1c.042.552.977.807.977,2.164a2.606,2.606,0,0,1-5.181-.467",
    transform: "translate(-147.809 -8.688)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M281.581,19.428a2.624,2.624,0,0,1-5.181,0,2.181,2.181,0,0,1,2.084-2.164V16.8c0-.68-.807-.68-.807-1.7h1.274c0,.595.807.68.807,1.486v.721a2.133,2.133,0,0,1,1.826,2.123m-1.316-.042a1.153,1.153,0,1,0-.382.857,1.152,1.152,0,0,0,.382-.857",
    transform: "translate(-159.029 -8.688)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M290.5,18.964v-.425h1.274v.34c0,1.1.51,1.571,1.316,1.571a1.162,1.162,0,0,0,1.274-1.274c0-1.486-2.038-1.911-2.038-3.694V15.1H293.6v.3c0,1.4,2.084,1.528,2.084,3.779a2.367,2.367,0,0,1-2.633,2.463,2.4,2.4,0,0,1-2.548-2.675",
    transform: "translate(-167.139 -8.688)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M305,19.426v-2.46a2.024,2.024,0,0,1,2.208-1.868h2.505v1.1h-2.336c-.595,0-1.1.255-1.1.892v.85a1.657,1.657,0,0,1,1.571-.721,2.211,2.211,0,0,1,2.293,2.208,2.329,2.329,0,0,1-2.59,2.208A2.291,2.291,0,0,1,305,19.426m3.779-.042a1.13,1.13,0,1,0-1.082,1.151,1.131,1.131,0,0,0,1.082-1.151",
    transform: "translate(-175.485 -8.686)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M318.9,19.319v-.255h1.274v.212a1.228,1.228,0,0,0,1.363,1.274c.85,0,1.363-.34,1.363-1.062,0-.68-.51-.977-1.363-.977h-.552V17.364h.68c.765,0,1.1-.3,1.1-.977V15.2h1.274v1.363a1.443,1.443,0,0,1-1.1,1.4,1.625,1.625,0,0,1,1.274,1.741c0,1.189-1.062,2.084-2.675,2.084-1.613-.085-2.633-.977-2.633-2.463",
    transform: "translate(-183.482 -8.745)",
    fill: "#6e6f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M333.9,17.532a2.509,2.509,0,1,1,5.011,0v3.907h-1.274V17.575c0-1.02-.51-1.486-1.231-1.486-.68,0-1.189.467-1.189,1.486v3.864h-1.274V17.532Z",
    transform: "translate(-192.111 -8.572)",
    fill: "#6e6f71"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBogicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/bog.icon.a5b26aee4cf9b8dccab44b399a9eef6d.svg";
export { ForwardRef as ReactComponent };